import React from "react";
import { LogoutOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import Button from "@components/common/Button/Button";
import Modal from "@components/common/Modal/Modal";
import { LOGOUT_MODAL_SHELL } from "@config/theme/modals";

interface LogoutConfirmationModalProps {
	show: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({ show, onConfirm, onCancel }) => {
	const { t } = useTranslation();

	return (
		<Modal
			isOpen={show}
			onClose={onCancel}
			title={t("psdaCommon.logout.title")}
			showCloseIcon
			width={LOGOUT_MODAL_SHELL.width}
			height={LOGOUT_MODAL_SHELL.height}
			rounded={LOGOUT_MODAL_SHELL.rounded}
			padding={LOGOUT_MODAL_SHELL.padding}
			footer={
				<div className="flex gap-4 border-t border-slate-200/90 pt-4">
					<Button
						variant="dangerTertiary"
						onClick={onCancel}
						className="flex-1 border-gray-300 text-gray-700 hover:bg-gray-50"
						text={t("psdaCommon.common.buttons.no")}
					/>
					<Button
						variant="dangerSecondary"
						onClick={onConfirm}
						className="flex-1"
						text={t("psdaCommon.common.buttons.yes")}
					/>
				</div>
			}>
			<div className="flex flex-col items-center">
				<div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-orange-100">
					<LogoutOutlined className="text-orange-500" sx={{ fontSize: "2rem" }} />
				</div>
				<p className="text-center text-gray-600">{t("psdaCommon.logout.description")}</p>
			</div>
		</Modal>
	);
};

export default LogoutConfirmationModal;
